








































import Vue from "vue";
import { mapState } from "vuex";
import { RootState } from "@/store";

import { Machine } from "@/model/data/Machine";

export default Vue.extend({
    props: {
        machine: Object as () => Machine,
        processedCashList: Array,
        nDays: Number,
        dateListString: Array,
        loading: Boolean,
        seriesPCTypeList: Array,
        seriesPCTrendList: Array,
    },
    computed: {
        ...mapState({
            userTheme: (state: RootState) => state.authMod.currentUser.userConfig.theme,
        }),
        isDepositMachine() {
            if (this.machine && this.machine.model) {
                if (this.machine.model.match(/SDM (500.*|100.*|50[A-Za-z\s]+|10[A-Za-z\s]+)/g)) return true;
            }
            return false;
        },
        chartProcessedCashType() {
            let categories = [this.$t("logAnalysis.deposited")];
            if (!this.isDepositMachine) categories.push(this.$t("logAnalysis.withdrawn"));
            return {
                options: {
                    theme: {
                        mode: this.userTheme,
                    },
                    chart: {
                        type: "bar",
                        animations: {
                            enabled: false,
                        },
                    },
                    grid: {
                        xaxis: {
                            lines: {
                                show: false,
                            },
                        },
                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 4,
                            horizontal: true,
                            barHeight: "50%",
                        },
                    },
                    dataLabels: {
                        enabled: false,
                    },
                    xaxis: {
                        categories: categories,
                    },
                    tooltip: {
                        y: {
                            formatter: (value) => new Intl.NumberFormat(navigator.language).format(value),
                        },
                    },
                },
                series: this.seriesPCTypeList,
            };
        },
        chartProcessedCashTrend() {
            return {
                options: {
                    theme: {
                        mode: this.userTheme,
                    },
                    chart: {
                        type: "bar",
                        stacked: true,
                        animations: {
                            enabled: false,
                        },
                        zoom: {
                            enabled: false,
                        },
                    },
                    grid: {
                        xaxis: {
                            lines: {
                                show: false,
                            },
                        },
                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 4,
                            horizontal: false,
                        },
                    },
                    dataLabels: {
                        enabled: false,
                    },
                    xaxis: {
                        type: "category",
                        categories: this.dateListString,
                        tickPlacement: "on",
                    },
                    tooltip: {
                        y: {
                            formatter: (value) => new Intl.NumberFormat(navigator.language).format(value),
                        },
                    },
                },
                series: this.seriesPCTrendList,
            };
        },
    },
});
